import axiosSetup from "../utils/axiosSetup";
import { ITaskData } from "../models/TaskData.model";

export const addTaskApi = async (taskData: ITaskData) => {
  const response = await axiosSetup.post("/task/add", taskData);
  return response.data;
};
export const fetchTasksApi = async (leadId: string) => {
  const response = await axiosSetup.get(`task/get/${leadId}`);
  return response.data.data[0].task;
};

export const updateTaskApi = async (payload: any) => {
  const response = await axiosSetup.put(`task/updateTask`, payload);

  return response.data.data;
};

export const getTaskRemarkApi = async (leadId: String) => {
  const response = await axiosSetup.get(`remark/remark/${leadId}`);
  return response.data;
};

export const getTodaysTask = async (date?: string, assignee?: string) => {
  const response = await axiosSetup.post("/task/todayTask", {
    date,
    assignee,
  });
  return response.data.data || [];
};

export const addTaskRemarkApi = async (
  taskId: String,
  remark: { text: String }
) => {
  const response = await axiosSetup.post(`remark/addRemark/`, {
    taskId,
    remark,
  });
  return response.data.data;
};

export const getTaskNotificationsApi = async () => {
  const response = await axiosSetup.get(`task/todayNotification`);
  return response.data.data;
};

export const getPendingTasksApi = async (assigneeId?: string | null) => {
  const response = await axiosSetup.get(`task/getPendingTask`, {
    params: {
      assignee: assigneeId,
    },
  });
  return response.data.data;
};
